import React, { useEffect, useRef } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { hasRequiredRole, login as startLogin } from "./keycloak";
import useInitTimeout from "./useInitTimeout";
import { AuthError, AuthLoading, NoAccess } from "./AuthStates";

const RequireAuth = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();
  const loginStarted = useRef(false);
  const timedOut = useInitTimeout(initialized);

  useEffect(() => {
    if (initialized && !keycloak.authenticated && !loginStarted.current) {
      loginStarted.current = true;
      startLogin();
    }
  }, [initialized, keycloak]);

  if (timedOut) {
    return <AuthError onRetry={() => window.location.reload()} />;
  }

  if (!initialized || !keycloak.authenticated) {
    return <AuthLoading />;
  }

  if (!hasRequiredRole(keycloak)) {
    return <NoAccess />;
  }

  return children;
};

export default RequireAuth;
